var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6 3.83004C20.7645 3.99359 20.867 4.20923 20.89 4.44004C21.13 6.92004 21.27 12.69 18 15.94C15.5338 18.4147 11.6205 18.6921 8.82997 16.59L4.55997 20.85C4.46609 20.9447 4.33829 20.9979 4.20497 20.9979C4.07166 20.9979 3.94386 20.9447 3.84997 20.85L3.14997 20.15C3.05532 20.0562 3.00208 19.9284 3.00208 19.795C3.00208 19.6617 3.05532 19.5339 3.14997 19.44L7.40997 15.2C5.29022 12.4039 5.56814 8.47037 8.05997 6.00004C10.58 3.46004 14.62 3.00004 17.3 3.00004C18.0547 2.99858 18.809 3.03529 19.56 3.11004C19.7895 3.13031 20.005 3.22922 20.17 3.39004L20.6 3.83004ZM10.25 15.16C12.2453 16.501 14.9124 16.2322 16.6 14.52C19.14 12 19.08 7.07004 18.94 5.06004C18.4 5.00004 17.85 5.00004 17.3 5.00004C15.27 5.00004 11.56 5.31004 9.47997 7.40004C7.76783 9.08761 7.49901 11.7548 8.83997 13.75L12.44 10.15C12.5339 10.0554 12.6617 10.0021 12.795 10.0021C12.9283 10.0021 13.0561 10.0554 13.15 10.15L13.85 10.85C13.9446 10.9439 13.9979 11.0717 13.9979 11.205C13.9979 11.3384 13.9446 11.4662 13.85 11.56L10.25 15.16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.19978826432cfce55ffc67fbcd71c2bf.svg";
export { ForwardRef as ReactComponent };